import React from 'react';
import { ArrowRight, Clock3 } from 'lucide-react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import {
  formatQueueDateTime,
  getCommandCenterCategoryLabel,
  getCommandCenterWorkspaceLabel,
  getQueueItemNavigation,
} from './commandCenterQueueUtils';

export default function LaterSection({ items, onOpenItem, onEditItem }) {
  if (!items.length) {
    return null;
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold text-slate-900 dark:text-white">Later</h3>
          <p className="text-sm text-slate-600 dark:text-gray-400">
            Deferred work stays visible here so it does not feel lost after it leaves the top three.
          </p>
        </div>
        <Badge className="border-slate-200 bg-white text-slate-700 dark:border-white/10 dark:bg-black/20 dark:text-slate-200">
          {items.length} queued
        </Badge>
      </div>

      <Card className="border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-[#171b20]">
        <div className="grid gap-3">
          {items.slice(0, 6).map((item) => {
            const hasExactDestination = Boolean(getQueueItemNavigation(item));
            return (
              <div
                key={item.queue_item_id}
                className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50/75 px-4 py-3 dark:border-white/10 dark:bg-white/[0.03] lg:flex-row lg:items-center lg:justify-between"
              >
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <Clock3 className="h-4 w-4 text-slate-500 dark:text-slate-300" />
                    <p className="text-sm font-semibold text-slate-900 dark:text-white">{item.title || 'Untitled action'}</p>
                    <Badge className="border-slate-200 bg-white text-slate-700 dark:border-white/10 dark:bg-black/20 dark:text-slate-200">
                      {getCommandCenterWorkspaceLabel(item.workspace)}
                    </Badge>
                    {item.category ? (
                      <Badge className="border-slate-200 bg-white text-slate-700 dark:border-white/10 dark:bg-black/20 dark:text-slate-200">
                        {getCommandCenterCategoryLabel(item.category)}
                      </Badge>
                    ) : null}
                  </div>
                  {item.detail ? (
                    <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-gray-300">{item.detail}</p>
                  ) : null}
                </div>
                <div className="flex flex-wrap items-center gap-2 lg:justify-end">
                  {item.due_at ? (
                    <span className="text-xs text-slate-500 dark:text-gray-400">
                      Due {formatQueueDateTime(item.due_at)}
                    </span>
                  ) : null}
                  {hasExactDestination ? (
                    <Button type="button" variant="outline" onClick={() => onOpenItem(item)}>
                      Open
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  ) : (
                    <Button type="button" variant="outline" disabled className="border-slate-200 text-slate-500 dark:border-white/10 dark:text-slate-400">
                      No destination yet
                    </Button>
                  )}
                  <Button type="button" variant="outline" onClick={() => onEditItem(item)}>
                    Edit
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
